import React from 'react';
import { FaSignOutAlt, FaHeart } from 'react-icons/fa';

function Header({ user, onLogout }) {
  return (
    <header className="sticky top-0 z-50 bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
        <div className="flex items-center gap-3">
          <FaHeart className="text-2xl" />
          <h1 className="text-2xl font-bold">Vedus Journey</h1>
        </div>

        <div className="flex items-center gap-4">
          {user && (
            <div className="flex items-center gap-2">
              <span className="text-sm">{user.attributes?.email}</span>
              <button
                onClick={onLogout}
                className="flex items-center gap-2 px-4 py-2 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-lg transition"
              >
                <FaSignOutAlt />
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
